module.exports = __webpack_public_path__ + "static/media/Pokereact1.0cb2e474.png";